module.exports = __webpack_public_path__ + "media/components/src/assets/images/tables/block_table_6-16ad425383e5958795fe37356fc655e6.jpg";